import React from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup } from "react-leaflet";
import { divIcon } from "leaflet";
import { SiteCollectionResource } from "../../../../resources/js/site/proptypes/site-collection-resource";

const LevelPill = (props) => {
    const { userlevel = 1, isPrivate } = props;
    if (isPrivate) {
        return <span className={`badge private-pill`}>Private</span>;
    }

    return <span className={`badge level-${userlevel}-pill`}>Level {userlevel}</span>;
};

const focusedIcon = () =>  divIcon({
    html: `<i class="pin fas fa-map-pin" style="color: #ff0000;"></i>`,
    iconSize: [15, 40],
    className: 'myDivIcon',
});

const bulldozerIcon = () =>  divIcon({
    html: `<i class="pin fas fa-snowplow" style="color: #a8a8a8;"></i>`,
    iconSize: [15, 40],
    className: 'myDivIcon',
});

const pinIcon = (level, focus=false) => divIcon({
    html: `<i class="pin fas ${focus ? "fa-map-pin" : "fa-map-marker-alt"} level-${focus ? '4' : level}-pin "></i><p class="caption"></p>`,
    iconSize: [15, 40],
    className: 'myDivIcon',
});

const getIcon = (site, isSelected, isColorCoded) => {
    if (isSelected) return focusedIcon();

    if (!isColorCoded) return pinIcon(0);

    if (site.center) return pinIcon(site.level, true);

    if (site.is_private) return pinIcon('private');

    if (site.current_status === 'Demolished') return bulldozerIcon();

    return pinIcon(site.level);
};

const MapSiteMarker = (props) => {
    const {
        site,
        onSiteSelect,
        isSelected,
        isColorCoded,
    } = props;

    return (
        <Marker
            key={`marker-${site.id}`}
            icon={getIcon(site, isSelected, isColorCoded)}
            position={[site.lat, site.lng]}
        >
            <Popup>
                <p className="h4 mb-0">{site.title}</p>
                <div className="d-flex">
                    <div className="flex-grow-1">
                        <p className="m-0 fw-bold">
                            #{site.id}
                            <a target="_blank" href={`/browse/site/${site.id}`}>
                                <i className="fas fa-external-link-alt ms-2"/>
                            </a>
                        </p>
                        <p className="m-0 fw-bold">{site.current_status}</p>
                        <LevelPill userlevel={site.level} isPrivate={site.is_private}/>
                    </div>
                    <div className="d-flex">
                        <button className="btn btn-link h3" onClick={onSiteSelect}>
                            <span className="h3"><i className="fa-solid fa-angle-right"/></span>
                        </button>
                    </div>
                </div>
            </Popup>
        </Marker>
    );
};

LevelPill.propTypes = {
    isPrivate: PropTypes.bool,
};
LevelPill.defaultProps = {
    isPrivate: false,
};

MapSiteMarker.propTypes = {
    site: PropTypes.shape(SiteCollectionResource),
    onSiteSelect: PropTypes.func.isRequired,
    isSelected: PropTypes.bool,
    isColorCoded: PropTypes.bool,
};
MapSiteMarker.defaultProps = {
    isSelected: false,
    isColorCoded: false,
};

export default MapSiteMarker;
